module.exports = __webpack_public_path__ + "img/1483533336.c6901494.jpg";